import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  TextField as MuiTextField,
  Grid,
  CardHeader,
  Typography,
  MenuItem,
} from "@mui/material";
import { spacing } from "@mui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";

import SaveCancel from "../../../components/SaveCancel";
import useMkIpPool from "../../../hooks/useMkIpPool";
import PoolFields from "./components/PoolFields";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Alert = styled(MuiAlert)(spacing);

const validationSchema = Yup.object().shape({
  nas: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  status: Yup.string().required("Required"),
  name: Yup.string().required("Required"),
  addresses: Yup.string().required("Required"),
});

function EditPool() {
  const { getMkIpPool, mkIpPool, updateMkIpPool, isSubmitting } = useMkIpPool();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (Object.keys(mkIpPool).length !== 0) {
      console.log(mkIpPool.status, "mkIpPool.status");
      console.log(mkIpPool.nas, "naassnass1111111");
      const initialValues = {
        mkIpPoolId: mkIpPool.mkIpPoolId,
        nas: {
          value: mkIpPool.nas.nasId,
          label: mkIpPool.nas.nasName,
        },
        name: mkIpPool.name,
        addresses: mkIpPool.addresses,
        status: mkIpPool.status,
      };
      reset(initialValues);
    }
  }, [mkIpPool]);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const [status, setStatus] = useState({
    sent: false,
  });

  const [errorSubmit, setErrorSubmit] = useState({
    submit: "",
  });

  const { state } = useLocation();
  console.log(state, "location");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async (data) => {
    try {
      data["nas"] = {
        nasId: data.nas.value,
        nasName: data.nas.label,
      };
      await updateMkIpPool(data);
      navigate("/mikrotik-mgnt/pool/list");
      reset();
      dispatch(showSuccessSnackbar("MkIpPool update Successfully!"));
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to update MkIpPool"));
    }
  };

  const cancelBtn = () => {
    navigate("/mikrotik-mgnt/pool/list");
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Mikrotik Access Mgnt</Typography>
        <Typography>Pool</Typography>
        <Typography>Edit</Typography>
      </Breadcrumbs>
    );
  };

  const fetchData = async () => {
    await getMkIpPool(state.id);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Card mb={6}>
          <CardHeader title={t("edit_pool")} subheader={breadCrump()} />
          <CardContent>
            {status && status.sent && (
              <Alert severity="success" my={3}>
                Pool updated successfully!
              </Alert>
            )}

            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={6}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <PoolFields fields={validationSchema.fields} />
                <SaveCancel cancelBtn={cancelBtn} resetForm={reset} />
              </form>
            )}
          </CardContent>
        </Card>
      </FormProvider>
    </React.Fragment>
  );
}

export default EditPool;
